import React from 'react';
export function CalendarRecurringIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.601 7.748a.825.825 0 011.154.02.834.834 0 01.245.586v2.085a.835.835 0 01-.833.834h-2.083a.833.833 0 010-1.668h.222a3.315 3.315 0 00-5.562 1.725.834.834 0 01-1.636-.33 4.986 4.986 0 013.331-3.753 4.972 4.972 0 014.903 1.054.827.827 0 01.259-.553zM15.918 12.01a.834.834 0 01.974.989 4.994 4.994 0 01-3.333 3.753 4.979 4.979 0 01-4.905-1.049.828.828 0 01-.82.77.833.833 0 01-.834-.834v-2.085a.835.835 0 01.834-.834h2.083a.833.833 0 01.589 1.424.832.832 0 01-.59.245H9.68a3.33 3.33 0 005.581-1.725.835.835 0 01.657-.654z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3a1 1 0 00-2 0H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3h-1a1 1 0 10-2 0H9zM6 5h1a1 1 0 002 0h6a1 1 0 102 0h1a1 1 0 011 1v12a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1z"
  }));
}